const theme = require('./themes/main.json')

module.exports = {
  title: 'Upcoming Events',
  subTitle: 'Around the Big Thicket',
  maxNumberOfEvents: 50,
  monthsIntoTheFuture: 12,
  theme,
}
